<div class="dialer-container">
  <!-- Header -->
  <div class="dialer-header">
    <span class="title">Dialer</span>
    <div class="header-icons">
    <button [attr.guide]="'twillo-dialer-btn-1' + '__' + sanitizedUrl" class="close-btn" (click)="closeDialer()">✖</button>
    </div>
  </div>

  <!-- Country & Number Input -->
<div class="dialer-input">
  <input [attr.guide]="'twillo-dialer-inp-phone-number-to-call' + '__' + sanitizedUrl" type="tel"
         class="number-input"
         placeholder="Enter number"
         [(ngModel)]="phoneNumber"
         (input)="validatePhoneNumber()"
         autocomplete="tel"
         inputmode="tel"
         aria-label="Phone number to call"/>

  <!-- Success / Error Icon -->
  <mat-icon *ngIf="phoneNumber"
            [ngClass]="{'valid-icon': isValid, 'error-icon': !isValid}">
    {{ isValid ? 'check_circle' : 'cancel' }}
  </mat-icon>
</div>

<!-- Error Message -->
<div class="error-msg" *ngIf="!isValid && phoneNumber">
  <span>{{ errorMsg }}</span>
</div>



  <!-- Local Time -->
  <div class="dialer-info">
    Call Status: <strong>{{ callStatus }}</strong>
    <div class="timings">
      <div *ngIf="callInitiatedTime">Initiated: {{ callInitiatedTime | date:'mediumTime' }}</div>
  <div *ngIf="ringingStartTime">Ringing since: {{ ringingStartTime | date:'mediumTime' }} ({{ formatDuration(ringingDuration) }})</div>
  <div *ngIf="answeredTime">Answered: {{ answeredTime | date:'mediumTime' }} (time-to-answer: {{ formatDuration(timeToAnswer) }})</div>
  <div *ngIf="connectedTime">Connected since: {{ connectedTime | date:'mediumTime' }} (duration: {{ formatDuration(callDuration) }})</div>
  <div *ngIf="callDuration && !inCall">Total call duration: {{ formatDuration(callDuration) }}</div>
    </div>
  </div>

  <!-- Keypad -->
  <div class="dialer-keypad">
  <div class="keypad-grid">
    <button [attr.guide]="'twillo-dialer-btn-2' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('1')">
      <span class="digit">1</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-3' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('2')">
      <span class="digit">2</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-4' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('3')">
      <span class="digit">3</span>
    </button>

    <button [attr.guide]="'twillo-dialer-btn-5' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('4')">
      <span class="digit">4</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-6' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('5')">
      <span class="digit">5</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-7' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('6')">
      <span class="digit">6</span>
    </button>

    <button [attr.guide]="'twillo-dialer-btn-8' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('7')">
      <span class="digit">7</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-9' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('8')">
      <span class="digit">8</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-10' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('9')">
      <span class="digit">9</span>
    </button>

    <button [attr.guide]="'twillo-dialer-btn-11' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('*')">
      <span class="digit">*</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-12' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('0')">
      <span class="digit">0</span>
    </button>
    <button [attr.guide]="'twillo-dialer-btn-13' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('#')">
      <span class="digit">#</span>
    </button>
  </div>
</div>

  <!-- Bottom Controls -->
<div class="dialer-actions">
  <button [attr.guide]="'twillo-dialer-btn-14' + '__' + sanitizedUrl" class="call-btn" *ngIf="!inCall" (click)="call()"
    [disabled]="!phoneNumber || phoneNumber.trim().length < 10 || !isValid"> Call</button>

  <button [attr.guide]="'twillo-dialer-btn-15' + '__' + sanitizedUrl" class="call-btn red" *ngIf="inCall" (click)="hangup()">⏹ Hangup</button>
  <button [attr.guide]="'twillo-dialer-btn-16' + '__' + sanitizedUrl" class="backspace-btn" (click)="backspace()">⌫</button>
  <!-- <button [attr.guide]="'twillo-dialer-btn-17' + '__' + sanitizedUrl" class="clear-btn" (click)="clearNumber()">C</button> -->
  <button [attr.guide]="'twillo-dialer-btn-18' + '__' + sanitizedUrl" class="clear-btn" (click)="initDevice()">⚙️</button>
</div>
</div>
